
import { defineComponent, reactive, ref, UnwrapRef, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

interface FormState {
  email: string;
}

export default defineComponent({
  setup () {
    const router = useRouter()
    const api = process.env.VUE_APP_BASEURL
    const loading = ref<boolean>(false)

    const isSuccess = ref<boolean>(false)
    const isInvalidEmail = ref<boolean>(false)
    const hasError = ref<boolean>(false)

    const userState: UnwrapRef<FormState> = reactive({
      email: ''
    })

    const handleFinish = async () => {
      loading.value = true
      isSuccess.value = false
      isInvalidEmail.value = false
      hasError.value = false
      await axios.post(`${api}auth/send-reset-password`, userState).then((res) => {
        isSuccess.value = true
        loading.value = false
      }).catch((e) => {
        if (e.response.status === 422) {
          isInvalidEmail.value = true
        } else {
          hasError.value = true
        }

        loading.value = false
      })
    }

    const showLogin = () => {
      router.push('/login')
    }

    onMounted(() => {
      if(window.localStorage.getItem("PAYMENT_PORTAL_TOKEN")) {
        router.push('/personnel/dashboard')
      }
    })

    return {
      loading,
      userState,
      handleFinish,
      showLogin,
      isSuccess,
      isInvalidEmail,
      hasError
    }
  },
})
